export const InfoCircleIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.41675 4.58341H7.58342V5.75008H6.41675V4.58341ZM6.41675 6.91675H7.58342V10.4167H6.41675V6.91675ZM7.00008 1.66675C3.78008 1.66675 1.16675 4.28008 1.16675 7.50008C1.16675 10.7201 3.78008 13.3334 7.00008 13.3334C10.2201 13.3334 12.8334 10.7201 12.8334 7.50008C12.8334 4.28008 10.2201 1.66675 7.00008 1.66675ZM7.00008 12.1667C4.42758 12.1667 2.33341 10.0726 2.33341 7.50008C2.33341 4.92758 4.42758 2.83341 7.00008 2.83341C9.57258 2.83341 11.6667 4.92758 11.6667 7.50008C11.6667 10.0726 9.57258 12.1667 7.00008 12.1667Z" />
  </svg>
);
